import logo from '../resources/logo.png'

const ResultsPageHeader = () => {

    return (
        <div className="mobileapp-cont">
            <a href="/" className="mobileapp-a">
            	<img className="mobileapp-logo" src={logo} alt="logo"/>
            </a>
            <p className="mobileapp-logo-text">Trivtionary Mobile App is still in development</p>
        </div>
    )
}

export default ResultsPageHeader